import findLast from 'lodash/findLast';

import { IDifficultyFadeFactor, ITrainingWorkoutState } from './types';

const DIFFICULTY_FADE_FACTORS: IDifficultyFadeFactor[] = [
  { days: 0, factor: 0 },
  { days: 1, factor: 0 },
  { days: 7, factor: 0.05 },
  { days: 30, factor: 0.1 },
  { days: 60, factor: 0.2 },
];

export const msecInDays = 1000 * 60 * 60 * 24;

function getFadeFactor(timestamp: number) {
  const timeDelta = (Date.now() - timestamp * 1000) / msecInDays;
  const factor = findLast(DIFFICULTY_FADE_FACTORS, (factor) => factor.days < timeDelta);
  return factor ? factor.factor : 0;
}

/**
 * calculate next starting difficulty from the results of current gameplay and historical data
 * @param {number} finishedDifficulty finished difficulty from the last gameplay of the group
 * @param {number} reachedDifficulty reached difficulty - maximum from finished difficulties of past gameplays
 * @param {number} timestamp unix timestamp of the last saved gameplay
 */
export function calcNextDifficulty(finishedDifficulty: number, reachedDifficulty: number, timestamp: number) {
  const fadeFactor = getFadeFactor(timestamp);
  const levelsToDecrease = Math.round(fadeFactor * reachedDifficulty);
  return Math.min(Math.max(finishedDifficulty - levelsToDecrease, 0), reachedDifficulty); // do not allow difficulty be less than 0
}

/**
 * Find max reachDifficulty from given siblings
 * @param {Array<ITrainingWorkoutState> | null} array of given siblings or null if there no siblings
 * @returns {number} max reachDifficulty from siblings or 0
 */
export const getMaxReachDifficultyOfSiblings = (siblings?: Array<ITrainingWorkoutState> | null): number => {
  if (!siblings || !siblings.length) {
    return 0;
  }

  return siblings?.reduce((prev, curr) => (prev.reachDifficulty > curr.reachDifficulty ? prev : curr)).reachDifficulty;
};
